import React from 'react';
import './Workflows.css';

const Workflows = () => {
  const workflows = [
    { name: 'User Onboarding', status: 'Active', triggers: 3, lastRun: '1 hour ago' },
    { name: 'Data Sync', status: 'Active', triggers: 5, lastRun: '30 minutes ago' },
    { name: 'Backup Process', status: 'Paused', triggers: 1, lastRun: '2 days ago' },
    { name: 'Notification System', status: 'Active', triggers: 8, lastRun: '5 minutes ago' },
  ];

  return (
    <div className="workflows-page">
      <div className="main-title">Workflows</div>
      
      <div className="workflows-content">
        <div className="workflows-header">
          <div className="workflows-stats">
            <span className="stat-item">
              <span className="stat-number">4</span>
              <span className="stat-label">Total Workflows</span>
            </span>
            <span className="stat-item">
              <span className="stat-number">3</span>
              <span className="stat-label">Active</span>
            </span>
          </div>
          <button className="create-workflow-btn">+ Create Workflow</button>
        </div>
        
        <div className="workflows-list">
          {workflows.map((workflow, index) => (
            <div key={index} className="workflow-item">
              <div className="workflow-header">
                <div className="workflow-icon">⚙️</div>
                <div className="workflow-info">
                  <div className="workflow-name">{workflow.name}</div>
                  <div className="workflow-meta">
                    <span className="meta-item">{workflow.triggers} triggers</span>
                    <span className="meta-item">Last run: {workflow.lastRun}</span>
                  </div>
                </div>
                <div className="workflow-status">
                  <span className={`status-badge ${workflow.status.toLowerCase()}`}>
                    {workflow.status}
                  </span>
                </div>
              </div>
              <div className="workflow-actions">
                <button className="action-btn">Edit</button>
                <button className="action-btn">Run Now</button>
                <button className="action-btn">View Logs</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Workflows; 